import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import * as Counter from './Counter';
import * as WeatherForecasts from './WeatherForecasts';
import * as AccountService from './AccountStore';
import * as DOService from './ShipmentStore';
import * as InitialService from './InitialStore';
import * as AppointmentService from './AppointmentStore';
import * as CreditabilityService from './CreditabilityStore';
import * as SalesService from './SalesStore';
import * as FactoringService from './FactoringStore';

import { invoicesReducer } from '../reducers/AccountingReducers';
import { shipmentsReducer } from '../reducers/ShipmentReducer';
import { paymentReducer } from '../reducers/PaymentReducer';
import { profileReducer } from '../reducers/ProfileReducer';
import { invoiceReducer } from '../reducers/InvoiceReducer';

export default function configureStore(history, initialState) {
    const reducers = {
        counter: Counter.reducer,
        weatherForecasts: WeatherForecasts.reducer,
        account: AccountService.reducer,
        deliveryOrderData: DOService.reducer,
        initialData: InitialService.reducer,
        appointmentData: AppointmentService.reducer,
        creditabilityData: CreditabilityService.reducer,
        salesData: SalesService.reducer,
        factoringData: FactoringService.reducer,
        accountingData: invoicesReducer,
        shipmentData: shipmentsReducer,
        paymentData: paymentReducer,
        profileData: profileReducer,
        invoiceData: invoiceReducer
    };

    const middleware = [
        thunk,
        routerMiddleware(history)
    ];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
        enhancers.push(window.devToolsExtension());
    }

    if (localStorage.getItem("authToken")) {
        var user = JSON.parse(localStorage.getItem("authToken"));
        initialState = {
            account: { user }
        };
    }

    const rootReducer = combineReducers({
        ...reducers,
        routing: routerReducer
    });

    return createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js